import Vue from 'vue'
import Router from 'vue-router'
import TabBar from './modules/TabBar'
import User from './modules/User'
import Plugin from './modules/Plugin'
import Article from './modules/article'
import store from '../store'
import { ProtocolList, ProtocolType } from '~/utils/enum'

// 重封装路由方法
let history = []
const updateHistory = (_history) => { history = _history }
Router.prototype.$history = history
// 返回
const _back = Router.prototype.go
Router.prototype.$back = function() {
  if (history.length <= 1) {
    window.sessionStorage.removeItem('lastUrl')
    const url = window.location.origin + window.location.pathname
    window.open(url, '_self', '', true)
    return false
  }
  return _back.call(this, -1)
}
// 替换
const _replace = Router.prototype.replace
Router.prototype.$replace = function(arg, onResolve, onReject) {
  const _arg = { ...arg }
  _arg.params = Object.assign(_arg.params || {}, { __type: 'replace' })
  if (onResolve || onReject) {
    return _replace.call(this, _arg, onResolve, onReject)
  }
  return _replace.call(this, _arg).catch(err => err)
}
// 前进
const _push = Router.prototype.push
Router.prototype.$push = function(arg, onResolve, onReject) {
  const _arg = { ...arg }
  _arg.params = Object.assign(_arg.params || {}, { __type: 'push' })
  if (onResolve || onReject) {
    return _push.call(this, _arg, onResolve, onReject)
  }
  return _push.call(this, _arg).catch(err => err)
}

// hook 链接
const _open = window.open
Object.defineProperty(window, 'open', {
  set: (value) => {
    // _open = value
  },
  get: () => {
    return function() {
      const url = arguments[0]
      const protocol = url.match(/^([a-zA-Z0-9]+\:\/\/)/ig)[0]
      let protocolConfig = {}
      ProtocolList.forEach(_protocol => {
        if (_protocol.header === protocol) {
          protocolConfig = _protocol
        }
      })
      if (protocolConfig.header) {
        switch (protocol) {
          case ProtocolType.Coolapk:
            Vue.prototype.$dialog.confirm({
              title: '准备离开本站',
              message: '是否要打开酷安'
            }).then(() => {
              _open.apply(this, arguments)
            }).catch(() => { })
            break
          default:
            router.$push({
              name: protocolConfig.routerName,
              params: {
                id: url.match(/^[a-zA-Z0-9]+\:\/\/(.+)/i)[1]
              }
            })
            break
        }
      } else {
        _open.apply(this, arguments)
      }
    }
  }
})

Vue.use(Router)

// 默认路由配置
const commonRoutes = [
  {
    path: '/',
    redirect: '/tabBar'
  },
  {
    path: '',
    redirect: '/tabBar'
  },
  {
    path: '*',
    redirect: '/404'
  },
  {
    name: 'Search',
    path: '/search',
    component: resolve => require(['pages/search.vue'], resolve),
    meta: {
      title: '搜索',
      keepAlive: true
    }
  },
  {
    name: 'NotFound',
    path: '/404',
    component: resolve => require(['pages/404.vue'], resolve),
    meta: {
      title: '出了点小问题'
    }
  }
]

// 拼接路由模块
const routes = commonRoutes.concat(TabBar, User, Plugin, Article)

// 为路由添加path
routes.forEach(route => {
  route.path = route.path || '/' + (route.name || '')
  if (route.children) {
    route.children.forEach(routeChild => {
      routeChild.path = routeChild.path || (route.path + '/') + (routeChild.name || '')
    })
  }
})

// 分模块路由，合并传入Router
const router = new Router({
  routes
})

// 记录路由前进还是后退
const routerTransition = (to, from) => {
  let direction = ''
  if (to.params.__type === 'replace') {
    direction = 'forward'
    history.splice(history.length - 1, 1, to)
  } else if (to.params.__type === 'push') {
    direction = 'forward'
    history.splice(history.length, 0, to)
  }
  if (history.length === 0) {
    direction = 'forward'
    to.params.__type = 'push'
    history.splice(history.length, 0, to)
  }
  if (!to.params.__type && history.length !== 0) {
    // 返回hook
    if (history.length >= 2 && to.name === history[history.length - 2].name) {
      direction = 'reverse'
      history.splice(history.length - 1, 1)
    } else {
      direction = 'forward'
      history.splice(history.length, 0, to)
    }
  }
  updateHistory(history)
  direction && store.commit('globalData/updateDirection', direction)
}

// iframe反向影响url
const correctUrl = (url) => {
  // 存在iframe
  if (window.self !== window.top) {
    window.sessionStorage.setItem('lastUrl', url)
  }
}
// 路由拦截
router.beforeEach((to, from, next) => {
  correctUrl(`${window.location.origin + window.location.pathname}#${to.fullPath}`)
  // 设置页面标题
  document.title = to.meta && to.meta.title || 'via轻插件'
  // 从store获取token
  const token = store.getters['globalData/token']
  // 从store获取用户类型
  const user_type = store.getters['globalData/userInfo'] && store.getters['globalData/userInfo'].type

  // 存在token，不存在user_type则获取用户信息
  if (token && !user_type && to.name !== 'Login') {
    store.dispatch('globalData/getMeInfo').then(res => {
      routerTransition(to, from)
      next()
    }).catch(() => {
      Vue.prototype.$toast('登录失效')
      store.commit('globalData/updateToken', '')
      next({
        name: 'Login',
        params: {
          redirectName: to.name,
          __type: 'push'
        }
      })
    })
    return
  }

  // 检查需要登录的页面是否已登录
  if (to.meta && to.meta.rols && to.meta.rols.length > 0 && !token && to.name !== 'login') {
    Vue.prototype.$toast('请输先登录')
    next({
      name: 'Login',
      params: {
        redirectName: to.name,
        __type: 'push'
      }
    })
    return
  }

  // 记录前进还是后退
  routerTransition(to, from)
  next()
  return
})

export default router
